/**
 * Main JavaScript for Jory Landing Theme
 * Handles mobile menu, smooth scrolling, and other interactions
 */

(function() {
    'use strict';

    // Mobile Menu Toggle
    function initMobileMenu() {
        const menuToggle = document.getElementById('mobile-menu-toggle');
        const mobileMenu = document.getElementById('mobile-menu');
        
        if (menuToggle && mobileMenu) {
            menuToggle.addEventListener('click', function() {
                mobileMenu.classList.toggle('hidden');
                
                // Toggle icon between hamburger and X
                const icon = this.querySelector('svg');
                if (mobileMenu.classList.contains('hidden')) {
                    icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />';
                } else {
                    icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />';
                }
            });
            
            // Close mobile menu when clicking on a link
            const menuLinks = mobileMenu.querySelectorAll('a');
            menuLinks.forEach(function(link) {
                link.addEventListener('click', function() {
                    mobileMenu.classList.add('hidden');
                    const icon = menuToggle.querySelector('svg');
                    icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />';
                });
            });
        }
    }

    // Smooth Scrolling for Anchor Links
    function initSmoothScroll() {
        const links = document.querySelectorAll('a[href^="#"]');
        
        links.forEach(function(link) {
            link.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                
                // Skip empty anchors and # only
                if (href === '#' || href === '') {
                    return;
                }
                
                const target = document.querySelector(href);
                
                if (target) {
                    e.preventDefault();
                    
                    // Get navbar height for offset
                    const navbar = document.querySelector('nav');
                    const offset = navbar ? navbar.offsetHeight : 0;
                    
                    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    // Add scroll effect to navbar
    function initNavbarScroll() {
        const navbar = document.querySelector('nav');
        
        if (navbar) {
            window.addEventListener('scroll', function() {
                if (window.scrollY > 10) {
                    navbar.classList.add('shadow-md');
                } else {
                    navbar.classList.remove('shadow-md');
                }
            });
        }
    }

    // Lazy load images with fade-in effect
    function initLazyImages() {
        const images = document.querySelectorAll('img[loading="lazy"]');
        
        if ('IntersectionObserver' in window) {
            const imageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        img.classList.add('fade-in');
                        observer.unobserve(img);
                    }
                });
            });
            
            images.forEach(function(img) {
                imageObserver.observe(img);
            });
        }
    }

    // Handle responsive tables (wrap in scrollable container)
    function initResponsiveTables() {
        const tables = document.querySelectorAll('.gh-content table');
        
        tables.forEach(function(table) {
            if (!table.parentElement.classList.contains('table-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper overflow-x-auto my-8';
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
                table.className += ' min-w-full divide-y divide-gray-200';
            }
        });
    }

    // Add copy button to code blocks
    function initCodeCopy() {
        const codeBlocks = document.querySelectorAll('pre code');
        
        codeBlocks.forEach(function(block) {
            const pre = block.parentElement;
            
            // Create copy button
            const button = document.createElement('button');
            button.className = 'absolute top-2 right-2 px-3 py-1 text-sm bg-gray-700 text-white rounded hover:bg-gray-600 transition-colors';
            button.textContent = 'Copy';
            
            // Make pre relative for button positioning
            pre.style.position = 'relative';
            pre.appendChild(button);
            
            button.addEventListener('click', function() {
                const code = block.textContent;
                
                navigator.clipboard.writeText(code).then(function() {
                    button.textContent = 'Copied!';
                    setTimeout(function() {
                        button.textContent = 'Copy';
                    }, 2000);
                }).catch(function(err) {
                    console.error('Failed to copy code: ', err);
                });
            });
        });
    }

    // Initialize floating QR code
    function initFloatingQR() {
        const qrContainer = document.getElementById('qr-code');
        const qrWrapper = document.getElementById('floating-qr-container');
        
        if (!qrContainer || !qrWrapper) return;
        
        // Get the URL from the data attribute or closest link
        const heroLink = document.querySelector('header a[href*="apple.com"], header a[href*="testflight"]');
        
        if (heroLink && heroLink.href) {
            try {
                // Generate QR code using QRCode.js library
                new QRCode(qrContainer, {
                    text: heroLink.href,
                    width: 128,
                    height: 128,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                });
            } catch (error) {
                console.error('Failed to generate QR code:', error);
                // Hide the container if QR generation fails
                qrWrapper.style.display = 'none';
            }
        } else {
            // Hide QR code if no download link found
            qrWrapper.style.display = 'none';
        }
    }

    // Handle email signup form (for PreSignUp header)
    function initEmailSignup() {
        const form = document.querySelector('[data-members-form]');
        if (!form) return;
        
        const emailInput = form.querySelector('[data-members-email]');
        const submitButton = form.querySelector('[data-members-submit]');
        const successMessage = form.parentElement.querySelector('[data-members-success]');
        const errorMessage = form.parentElement.querySelector('[data-members-error]');
        
        form.addEventListener('submit', async function(e) {
            e.preventDefault();
            
            if (!emailInput || !emailInput.value) return;
            
            // Disable form during submission
            emailInput.disabled = true;
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
            
            try {
                // Simulate API call (replace with actual Ghost Members API integration)
                await new Promise(resolve => setTimeout(resolve, 1500));
                
                // Show success message
                successMessage.classList.remove('hidden');
                errorMessage.classList.add('hidden');
                emailInput.value = '';
                
                // Reset button after delay
                setTimeout(() => {
                    submitButton.textContent = 'Join waitlist';
                    emailInput.disabled = false;
                    submitButton.disabled = false;
                }, 2000);
                
            } catch (error) {
                // Show error message
                errorMessage.classList.remove('hidden');
                successMessage.classList.add('hidden');
                
                // Reset button
                submitButton.textContent = 'Join waitlist';
                emailInput.disabled = false;
                submitButton.disabled = false;
            }
        });
    }

    // Initialize all functions when DOM is ready
    function init() {
        initMobileMenu();
        initSmoothScroll();
        initNavbarScroll();
        initLazyImages();
        initResponsiveTables();
        initCodeCopy();
        initEmailSignup();
        initFloatingQR();
        // Scroll reveals are handled by motion-animations.js (Motion.dev)
        // which is loaded as <script type="module"> in default.hbs
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
